module.exports = __webpack_public_path__ + "img/manual-fuvest.306ecb13.png";